<template>
	<div class="p-6">
		<h1 class="text-2xl font-semibold text-gray-900 mb-6">
			{{ __("Loading and unloading details") }}
		</h1>
		<div class="space-y-4">
			<div class="text-gray-500">
				<ui-input-group
					class="mb-1"
					v-model="form.extra.loading_schedule"
					field="extra.loading_schedule"
					label="Loading times/Unloading times"
					:form="form"
					:required="false"
				></ui-input-group>
				{{ __("E.g. Mon-Fri 08:00-12:00(am), Tue,Thu 04:00-05:00 (pm)") }}
			</div>

			<ui-input-group
				v-model="form.extra.loading_performance_hourly"
				field="extra.loading_performance_hourly"
				suffix="t/h"
				label="Loading rate/Unloading rate"
				:form="form"
				:required="false"
			></ui-input-group>

			<div class="text-gray-500">
				<ui-input-group
					class="mb-1"
					v-model="form.extra.comment"
					field="extra.comment"
					label="Additional information"
					:form="form"
					:required="false"
				></ui-input-group>
				{{
					__(
						"This information is displayed to your trading partners in the bidding process"
					)
				}}
			</div>

			<div class="text-gray-500">
				<ui-input-group
					v-model="form.extra.fulfilment_info"
					field="extra.fulfilment_info"
					label="Processing information"
					:form="form"
					:required="false"
				></ui-input-group>
				{{
					__(
						"This information is transmitted to your trading partners when the contract is closed"
					)
				}}
				<ui-tooltip
					:icon-stroke-width="1.5"
					:text="
						__('Will be listed in the e-mail with the closing certificate')
					"
				></ui-tooltip>
			</div>

			<div>
				<p class="font-medium text-gray-700">{{ __("Clearance") }}</p>

				<div class="flex space-x-6 mt-1">
					<ui-radio-group
						class="col-span-2"
						:key="'RESTRICTED-' + form.extra.max_height_limited"
						v-model="form.extra.max_height_limited"
						radioValue="1"
						name="extra.max_height_limited"
						label="Limited"
					></ui-radio-group>

					<ui-radio-group
						class="col-span-2"
						:key="'LIMITED-' + form.extra.max_height_limited"
						v-model="form.extra.max_height_limited"
						radioValue="0"
						name="extra.max_height_limited"
						label="Unlimited"
					></ui-radio-group>
				</div>

				<div class="grid grid-col-3 gap-x-6">
					<ui-input-group
						v-if="form.extra.max_height_limited == '1'"
						v-model="form.extra.max_height"
						field="extra.max_height"
						suffix="m"
						:form="form"
						:required="false"
					></ui-input-group>
				</div>
			</div>

			<div>
				<p class="font-medium text-gray-700">{{ __("Means of Transport") }}</p>
				<div class="mt-1 space-y-2">
					<ui-radio-group
						class="col-span-2"
						:key="'ALL-' + form.extra.special_vehicles_only"
						v-model="form.extra.special_vehicles_only"
						radioValue="0"
						name="extra.special_vehicles_only"
						label="All vehicle types possible"
					></ui-radio-group>
					<ui-radio-group
						class="col-span-2"
						:key="'SELECTED-' + form.extra.special_vehicles_only"
						v-model="form.extra.special_vehicles_only"
						radioValue="1"
						name="extra.special_vehicles_only"
						label="Only the following vehicle types possible:"
					></ui-radio-group>
				</div>
				<ui-button-select
					class="grid grid-cols-3 gap-x-4"
					v-if="form.extra.special_vehicles_only == '1'"
					v-model="form.extra.special_vehicles_allowed"
					:options="specialVehicleOptions"
					:key="'specialVehicleOptions-' + specialVehicleOptions.length"
				/>
			</div>

			<!-- {{ __('Weighing') }} -->
			<ui-check-group
				v-model="form.extra.has_scales"
				field="extra.has_scales"
				label="Yes, weighing is possible"
				:form="form"
			></ui-check-group>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			specialVehicleOptions: this.$cropOptions.specialVehicleOptions,
		};
	},
};
</script>
